import React, { useState, useEffect } from 'react';
import CriticalityListLayer from './CriticalityListLayer';
import AssetTypeListLayer from './AssetTypeLayer';
import AssetLocationListLayer from './AssetLocationListLayer';
import PlanningTypeLayer from './PlanningTypeLayer';
import PlantStatusLayer from './PlantStatusLayer';
import PlanningGroupListLayer from './PlanningGroupListLayer';
import { useSetting } from '../utils/AppSettingsContext';

const tabs = [
  { key: 'criticality', label: 'Asset Criticality', Component: CriticalityListLayer },
  { key: 'assetType', label: 'Asset Type', Component: AssetTypeListLayer },
  /* { key: 'locations', label: 'Asset Locations', Component: AssetLocationListLayer },*/
  { key: 'planningType', label: 'Planning Type', Component: PlanningTypeLayer },
  { key: 'status', label: 'Asset Status', Component: PlantStatusLayer },
  { key: 'planning', label: 'Planning Group', Component: PlanningGroupListLayer },
];

const AssetReferencesLayer = () => {
  const showExtraAssetFields = useSetting('show_extra_asset_fields');
  const displayedTabs = showExtraAssetFields
    ? tabs
    : tabs.filter(t => t.key !== 'planning');

  const [activeTab, setActiveTab] = useState(displayedTabs[0].key);

  useEffect(() => {
    if (!showExtraAssetFields && activeTab === 'planning') {
      setActiveTab(displayedTabs[0].key);
    }
  }, [showExtraAssetFields, activeTab, displayedTabs]);

  const ActiveComponent =
    displayedTabs.find(t => t.key === activeTab)?.Component ||
    displayedTabs[0].Component;
  return (
    <div className='card h-100 p-0 rounded-0 overflow-hidden'>
      <div className='card-body p-0'>
        <ul className='nav nav-tabs mb-3'>
          {displayedTabs.map(t => (
            <li key={t.key} className='nav-item'>
              <button
                className={`nav-link ${activeTab === t.key ? 'active' : ''}`}
                onClick={() => setActiveTab(t.key)}
              >
                {t.label}
              </button>
            </li>
          ))}
        </ul>
        <ActiveComponent />
      </div>
    </div>
  );
};

export default AssetReferencesLayer;
